import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ErrorMessage, Form } from '@anytag/shared-atoms';
import { TalentInfluencerFormValues } from '../../schema-types';
import { ConnectedAccounts } from './ConnectedAccounts';
import { useInitialTalentSocialAccounts, useTalentInfluencerConnectSocialAccount } from './hooks';

export const SocialAccountsSection = () => {
  const { t } = useTranslation();
  const {
    watch,
    getValues,
    formState: { errors }
  } = useFormContext<TalentInfluencerFormValues>();
  const values = getValues();
  const influencerId = watch('id');
  const { igAccounts, ytAccounts, fbAccounts, twitterAccounts } = useInitialTalentSocialAccounts({
    influencerId,
    values
  });
  const { handleConnect, handleReconnect, connecting, reconnecting } = useTalentInfluencerConnectSocialAccount({
    influencerId,
    values
  });

  return (
    <div className="relative">
      <Form.SectionTitle label={t('Social Account')} className="mb-0" />

      <ConnectedAccounts
        socialMedia="INSTAGRAM"
        accounts={igAccounts}
        loading={connecting || reconnecting}
        onReconnect={(data) => handleReconnect('INSTAGRAM', data)}
        onSignIn={(account) => handleConnect('INSTAGRAM', { instagramAccountName: account?.name })}
      />
      <ConnectedAccounts
        socialMedia="YOUTUBE"
        accounts={ytAccounts}
        className="mt-6"
        loading={connecting || reconnecting}
        onSignIn={(account) => handleConnect('YOUTUBE', { channelId: account?.id })}
      />
      <ConnectedAccounts
        limit={10000} // just set unlimited adding
        socialMedia="FACEBOOK"
        accounts={fbAccounts}
        className="mt-6"
        loading={connecting || reconnecting}
        onSignIn={() => handleConnect('FACEBOOK', { needOverrideFbFanpages: true })}
      />
      <ConnectedAccounts
        socialMedia="TWITTER"
        accounts={twitterAccounts}
        className="mt-6"
        loading={connecting || reconnecting}
        onSignIn={(account) => handleConnect('TWITTER', { screenName: account?.name })}
      />
      <ErrorMessage message={t<string>(errors.connectedFacebook?.message || '')} className="bottom-0" />
    </div>
  );
};
